import { Text, type TextProps } from '@chakra-ui/react'
import * as React from 'react'

/**
 * MutedLabel — Uppercase, muted metadata label.
 *
 * Replaces the repeated pattern:
 *   <Text fontSize="xs" color="fg.subtle" mb={1} textTransform="uppercase" fontWeight="medium">
 *     Label
 *   </Text>
 */

export interface MutedLabelProps extends TextProps {
    children: React.ReactNode
}

export const MutedLabel = React.forwardRef<HTMLParagraphElement, MutedLabelProps>(
    function MutedLabel({ children, ...rest }, ref) {
        return (
            <Text
                ref={ref}
                fontSize="xs"
                color="fg.subtle"
                mb={1}
                textTransform="uppercase"
                fontWeight="medium"
                {...rest}
            >
                {children}
            </Text>
        )
    }
)
